module.exports = __webpack_public_path__ + "static/img/net-core.e484b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/net-core.png
// module id = bm/W
// module chunks = 0